<table mat-table multiTemplateDataRows [dataSource]="dataSource" class="mat-elevation-z4">

  <ng-container matColumnDef="zeitspanne">
    <th mat-header-cell *matHeaderCellDef>Zeit</th>
    <td mat-cell *matCellDef="let element">{{element?.werteGanzerTag?.gueltigVonLokaleZeit | date: 'EEE dd.MM'}}
      - {{element?.werteGanzerTag?.gueltigBisLokaleZeit | date: 'EEE dd.MM'}}</td>
  </ng-container>

  <ng-container matColumnDef="wettersymbol">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon>cloud_queue</mat-icon>
    </th>
    <td mat-cell *matCellDef="let element"><img class="vorhersage-table-wettersymbol"
                                                src="{{datastoreService.getWetterSymbolUrl(element?.werteGanzerTag?.wettersymbol?.wert)}}">
    </td>
  </ng-container>

  <ng-container matColumnDef="temperaturMin">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon svgIcon="thermometer_min"></mat-icon>
    </th>
    <td mat-cell
        *matCellDef="let element">{{werteConverter.convertDecimalWithComma(element?.werteGanzerTag?.luftTemperaturMinimum.wert)}} {{element?.werteGanzerTag?.luftTemperaturMinimum.einheit}}</td>
  </ng-container>

  <ng-container matColumnDef="temperaturMax">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon svgIcon="thermometer_max" style="color: orange"></mat-icon>
    </th>
    <td mat-cell
        *matCellDef="let element">{{werteConverter.convertDecimalWithComma(element?.werteGanzerTag?.luftTemperaturMaximum.wert)}} {{element?.werteGanzerTag?.luftTemperaturMaximum.einheit}}</td>
  </ng-container>

  <ng-container matColumnDef="niederschlag">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon>umbrella</mat-icon>
    </th>
    <td mat-cell
        *matCellDef="let element">{{element?.werteGanzerTag?.niederschlagsWahrscheinlichkeit.wert}} {{element?.werteGanzerTag?.niederschlagsWahrscheinlichkeit.einheit}}</td>
  </ng-container>

  <ng-container matColumnDef="windrichtung">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon>air</mat-icon>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-icon
        matTooltip="{{element?.werteGanzerTag?.windRichtung.wert +  element?.werteGanzerTag?.windRichtung.einheit}}"
        class="mat_icon_subtitle">{{werteConverter.getWindrichtungsIconByText(element?.werteGanzerTag?.windRichtung.text)}}</mat-icon>
      <mat-label class="table-icon-label">{{element?.werteGanzerTag?.windRichtung.text}}</mat-label>
    </td>
  </ng-container>

  <ng-container matColumnDef="windgeschwindigkeit">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon>speed</mat-icon>
    </th>
    <td mat-cell
        *matCellDef="let element">{{element?.werteGanzerTag?.mittlereWindGeschwindigkeit.wert | number :'1.0-0':'de'}} {{element?.werteGanzerTag?.mittlereWindGeschwindigkeit.einheit}}</td>
  </ng-container>

  <ng-container matColumnDef="accordionExpansion">
    <th mat-header-cell *matHeaderCellDef></th>
    <td *matCellDef="let element" mat-cell>
      <mat-icon *ngIf="element !== expandedElement">keyboard_arrow_down</mat-icon>
      <mat-icon *ngIf="element === expandedElement">keyboard_arrow_up</mat-icon>
    </td>
  </ng-container>

  <!--Hier Details anzeigen -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
      <div class="vorhersage-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        <app-24h-vorhersage-table-detail [element]="element"></app-24h-vorhersage-table-detail>
      </div>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;"
      class="vorhersage-element-row"
      [class.vorhersage-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"></tr>
  <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="expanded-vorhersage-detail-row"></tr>
</table>
